const governmentState = {
	Guid:'',
	articleListType:'',
	attrForSelect:'',
	emileAddress:'',
	webchanneltypeid:'',
	isdefault:'',
	sendTagsList:[],
	hotWords:[],
	breadcrumbData:'',
	breadcrumbDataFirst:''
};

export default governmentState;
